module.exports = __webpack_public_path__ + "img/mensaje-documento-eliminado.deb0e829.png";